import { StoreProvider } from 'easy-peasy';
import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { ChromecastProvider } from './components/ChromecastProvider';
import { MuxProvider } from './components/MuxProvider';
import { Player } from './components/Player';
import { VHSProvider } from './components/VHSProvider';
import { store } from './store';
import { VideoPlayerProps } from './typings';
import theme from './utils/theme';

export * from './utils/store-actions-map';

export type { VideoPlayerExternalAPI } from './api/external-api';
export { ErrorCodes } from './errors/ErrorCodes';
export { PlayerError } from './errors/PlayerError';
export type { store } from './store';
export type { AudioTrack, VideoPlayerProps } from './typings';

export const WebVideoPlayer: React.FunctionComponent<VideoPlayerProps> = React.memo((props: VideoPlayerProps) => {
  return (
    <StoreProvider store={store}>
      <MuxProvider>
        <VHSProvider>
          <ChromecastProvider>
            <ThemeProvider theme={theme}>
              <Player {...props} />
            </ThemeProvider>
          </ChromecastProvider>
        </VHSProvider>
      </MuxProvider>
    </StoreProvider>
  );
});
